import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    svgIconSection: {
        marginTop: '40px',
    },
    svgIcon:{
        filter: 'invert(39%) sepia(15%) saturate(1244%) hue-rotate(180deg) brightness(90%) contrast(91%);',
    },
    textSection: {
        maxWidth: '80%',
        margin: '40px 0 30px 0'
    },
    text: {
        fontSize: 33,
        lineHeight: '1.2em'
    },
    questionnaire: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    questionnaireHeader: {
        width: '100%',
        height: '40px',
        lineHeight: '40px',
        paddingLeft: 5,
        textAlign: 'left',
        color: theme.palette.secondary.dark,
        fontSize: 18,
        fontWeight: 'bold',
        backgroundColor: theme.palette.primary.light,
        display: 'flex',
        justifyContent: 'space-between',
    },
    questionnaireBody: {
        padding: theme.spacing(2),
        textAlign: 'left'
    },
    questionaireQuestionSet: {
        marginBottom: theme.spacing(2)
    },
    questionnaireQuestion: {
        fontSize: 20,
        fontWeight: 'bold',
    }
}));

export default useStyles;